<template>
  <div>
    <v-tooltip bottom>
      <template #activator="{ on, attrs }">
        <div v-bind="attrs" v-on="on">
          <v-combobox
            v-model="val"
            v-show-fade="{ isFilter: isFilter }"
            :items="eventPlaceNames"
            v-bind="[$attrs]"
            :loading="$apollo.queries.eventPlaceNames.loading"
            :search-input.sync="search"
            :menu-props="menuProperties"
            :class="[selectMixinClass]"
            append-icon="$iconSearch"
            :label="label"
            no-filter
            :data-test="dataTest"
            hide-no-data
            no-data-text
            :dense="dense"
            :hide-details="isFilter || dense"
            :clearable="clearable"
            outlined
            @change="inputVisibility($event, 'change')"
            @focus="focused"
            @blur="inputVisibility"
            @update:search-input="searchInput($event)"
          />
        </div>
      </template>
      <span>{{ tooltipText }}</span>
    </v-tooltip>
  </div>
</template>

<script>
import selectsMixin from "./selects_mixin";
import gql from "fraql";

export default {
  name: "AppSelectPlace",
  mixins: [selectsMixin],
  props: {
    menuProps: {
      type: Object,
      default: null
    },
    dense: {
      type: Boolean,
      default: false
    },
    dataTest: {
      type: String,
      default: "place"
    },
    label: {
      type: String,
      default() {
        return this.$t(
          "common:place.filter.label",
          "Place",
          "Label of the place filter in different context"
        );
      }
    }
  },
  data() {
    return {
      eventPlaceNames: [],
      search: "",
      menuProperties: {},
      isComboboxComponent: true
    };
  },
  computed: {
    val: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  },
  beforeMount() {
    if (this.value) this.eventPlaceNames.push(this.value);
  },
  created() {
    if (this.menuProps) {
      this.menuProperties = Object.assign(this.menuProperties, this.menuProps);
    }
  },
  methods: {
    searchInput(evt) {
      if (!evt) return;
      this.val = evt;
    }
  },
  apollo: {
    eventPlaceNames: {
      query: gql`
        query eventPlaceNames($search: String) {
          eventPlaceNames(search: $search)
        }
      `,
      variables() {
        return {
          search: this.search
        };
      },
      debounce: 750,
      skip() {
        if (this.value) this.search = this.value;
        return !this.selection ? !this.search || this.search.length < 3 : false;
      },
      result({ data }) {
        if (this.value) this.selection = this.value;
        if (!data || !data.eventPlaceNames || data.eventPlaceNames.length == 0)
          this.eventPlaceNames = [];
        else this.eventPlaceNames = data.eventPlaceNames;
      }
    }
  }
};
</script>
